import { onBeforeMount } from 'vue'

import type { PortalAdTargeting } from '@/modules/adv/types'
import { useAdsStore } from '@/store/ads-store'

export const useSetAdTargetingOnMount = (targeting: PortalAdTargeting | undefined) => {
    const adsStore = useAdsStore()

    // oxlint-disable-next-line playgama/no-on-before-mount
    onBeforeMount(() => {
        if (targeting) {
            adsStore.updateTargeting(targeting)
        }
    })
}
